import { Controller, useFormContext } from 'react-hook-form'

import { Box } from '@factorialco/deprecated-design-system'

import NumberField from 'modules/core/components/NumberField'
import i18n from 'modules/core/lib/i18n'

import { castError } from '../../castError'
import withCustomizationFields, {
  WithCustomizationFieldsProps,
} from '../../withCustomizationFields'
import withFieldPermissions, { WithFieldPermissionsProps } from '../../withFieldPermissions'

const FIELD_NAME = 'amount'

interface Props extends WithCustomizationFieldsProps, WithFieldPermissionsProps {
  currency: string
  isAutomaticExpensable?: boolean
}

const AmountField = ({
  currency,
  isFieldMandatory,
  isAutomaticExpensable = false,
  isFieldReadOnly,
  resourceType,
}: Props) => {
  const {
    watch,
    control,
    trigger,
    formState: { errors },
  } = useFormContext()

  const documentType = watch('documentType')
  const label =
    documentType === 'invoice'
      ? i18n.t('expenses_v2.forms.fields.total_amount.label_invoice')
      : documentType === 'receipt'
      ? i18n.t('expenses_v2.forms.fields.total_amount.label_receipt')
      : i18n.t('expenses_v2.forms.fields.total_amount.label_other')

  const isMileage = resourceType === 'mileage'

  const calculatedLabel = isMileage
    ? i18n.t('expenses_v2.forms.new_form.fields.mileage.amount.label')
    : label
  const isReadOnly = isFieldReadOnly || isAutomaticExpensable

  return (
    <Box width="full">
      <Controller
        name={FIELD_NAME}
        control={control}
        render={({ field }) => (
          <>
            <NumberField
              label={calculatedLabel}
              value={field.value}
              indicator={currency}
              placeholder={'0'}
              mandatory={isFieldMandatory ?? false}
              maxDecimals={2}
              readonly={isReadOnly}
              onChange={(value) => {
                field.onChange(value)
                trigger() //needed to trigger the validation of the taxes
              }}
              error={castError(errors?.amount)}
            />
          </>
        )}
      />
    </Box>
  )
}

export default withCustomizationFields(withFieldPermissions(AmountField, FIELD_NAME))
